import request from '@/api/request'

/**
 * 订单列表
 */
export function orderListApi (query) {
  return request({
    url: '/auth/order/list',
    method: 'get',
    params: query
  })
}

/**
 * 订单详情
 */
export function orderInfoApi (query) {
  return request({
    url: '/auth/order/info',
    method: 'get',
    params: query
  })
}

/**
 * 订单文书
 */
export function orderInstrumentApi (query) {
  return request({
    url: '/auth/order/instrument',
    method: 'get',
    params: query
  })
}

/**
 * 删除订单
 */
export function orderDelApi (data) {
  return request({
    url: '/auth/order/del',
    method: 'put',
    data
  })
}

/**
 * 撤销订单
 */
export function orderBackApi (data) {
  return request({
    url: '/auth/order/back',
    method: 'put',
    data
  })
}

/**
 * 订单材料
 */
export function orderMaterialListApi (query) {
  return request({
    url: '/auth/order/material_list',
    method: 'get',
    params: query
  })
}

/**
 * 上传材料
 */
export function orderMaterialUploadApi (data) {
  return request({
    url: '/auth/order/material_upload',
    method: 'post',
    data
  })
}

/**
 * 保存订单材料
 */
export function orderMaterialApi (data) {
  return request({
    url: '/auth/order/material',
    method: 'post',
    data
  })
}

/**
 * 材料说明
 */
export function orderMaterialDescApi (query) {
  return request({
    url: '/auth/order/material_desc',
    method: 'get',
    params: query
  })
}

/**
 * 订单支付方式
 */
export function orderOrgPayApi (query) {
  return request({
    url: '/auth/order/org_pay',
    method: 'get',
    params: query
  })
}

/**
 * 订单线下支付
 */
export function orderOfflinePayApi (query) {
  return request({
    url: '/auth/order/offline_pay',
    method: 'post',
    params: query
  })
}

/**
 * 订单微信支付
 */
export function orderWeiXinPayApi (query) {
  return request({
    url: '/auth/order/wei_xin_pay',
    method: 'post',
    params: query
  })
}

/**
 * 订单支付宝支付
 */
export function orderAliPayApi (query) {
  return request({
    url: '/auth/order/ali_pay',
    method: 'post',
    params: query
  })
}

/**
 * 订单留言列表
 */
export function orderMsgListApi (query) {
  return request({
    url: '/auth/order/msg_list',
    method: 'get',
    params: query
  })
}

/**
 * 订单留言
 */
export function orderMsgApi (data) {
  return request({
    url: '/auth/order/msg',
    method: 'post',
    data
  })
}

/**
 * 取消撤销
 */
export function cancelRevocationApi (data) {
  return request({
    url: '/auth/order/cancel_revocation',
    method: 'put',
    data
  })
}

/**
 * 取消撤销
 */
export function wxWechatQrCodeApi (query) {
  return request({
    url: '/wx/wechat/qrCode',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/my/bid.js